import {TableChartWrapper} from 'views/storyboard/charts/table/TableChartWrapper';

export default TableChartWrapper;
